import { atom } from 'jotai';

export const isInspiringSearchOnboardingOpenAtom = atom(false);
